import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

const Options = (props) => {
    const setVal = (e) => {
        props.onChange(e.target.value,e.target.name);
    };

    const type=props.options.type;

    return (
        <div id={'options'}>
            <Form>
                <fieldset>
                    <legend>Anaglyph:</legend>
                    <label>
                        <input type="radio" name="type" value="optimized" checked={type === 'optimized'}
                            onChange={setVal}/> Optimized
                    </label>
                    <label>
                        <input type="radio" name="type" value="dubois"
                            checked={type === 'dubois'} onChange={setVal}/> Dubois </label>
                    <label>
                        <input type="radio"
                            name="type" value="grey" checked={type === 'grey'} onChange={setVal}/> Grey<br/>
                    </label>
                    <label>
                        <input
                            type="radio" name="type" value="true" checked={type === 'true'} onChange={setVal}/> True<br/>
                    </label>
                    <label>
                        <input type="radio" name="type" value="color" checked={type === 'color'}
                            onChange={setVal}/> Full Color<br/>
                    </label>
                    <label>
                        <input type="radio" name="type" value="halfcolor"
                            checked={type === 'halfcolor'} onChange={setVal}/> Half Color
                    </label>
                </fieldset>
                <fieldset>
                    <legend>Pair:</legend>
                    <label>
                        <input type="radio" name="type" value="parallel" checked={type === 'parallel'}
                            onChange={setVal}/> Parallel
                    </label>
                    <label>
                        <input type="radio" name="type" value="crosseye"
                            checked={type === 'crosseye'} onChange={setVal}/> Crosseye
                    </label>
                    <label>
                        Gap <input type="number" name="gap" min={0} max={50} step={1} defaultValue={2}  onChange={setVal}/>%
                    </label>
                </fieldset>
                <fieldset>
                    <legend>Single:</legend>
                    <input type="radio" name="type" value="left" checked={type === 'left'}
                        onChange={setVal}/> Left<br/>
                    <input type="radio" name="type" value="right"
                        checked={type === 'right'} onChange={setVal}/> Right<br/>
                </fieldset>
            </Form>
        </div>
    );
};

Options.propTypes = {
    onChange: PropTypes.func,
    options: PropTypes.object
};

export default Options;
